module.exports = __webpack_public_path__ + "img/openbadge-info-1.aab5f53c.png";